import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = ({ color = designSystem.colors.neutral300, ...props }) => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <Path
            fill={color}
            d="m14.096 10.932-.53.53.53-.53ZM9.5 17.65l.53.53 4.597-4.596-.53-.53-.531-.53L8.97 17.12l.53.53Zm4.596-6.717.53-.53-4.596-4.597-.53.53-.53.53 4.596 4.597.53-.53Zm0 2.12.53.531a2.25 2.25 0 0 0 0-3.182l-.53.53-.53.53a.75.75 0 0 1 0 1.062l.53.53Z"
        />
    </Svg>
);
export default SvgComponent;
